export default {
  ADMIN: '/admin',
  BUILDING: '/:buildingTokenId',
  HOME: '/',
  PAGE_NOT_FOUND: '/404',
};
